import { Pipe, PipeTransform } from '@angular/core';

import { DealerAssistTableErrorCode } from '../models/communication/app-enums.model';

@Pipe({
    name: 'errorCode',
    standalone: true
})
export class ErrorCodePipe implements PipeTransform {
    transform(value: DealerAssistTableErrorCode): string {
        return ErrorCodePipe.stringToDescription(value);
    }

    static stringToDescription(value: DealerAssistTableErrorCode): string {
        switch (value) {
            case DealerAssistTableErrorCode.BackendDisconnected:
                return $localize`Backend disconnected`;
            case DealerAssistTableErrorCode.RoundOpeningFailed:
                return $localize`Round opening failed`;
            case DealerAssistTableErrorCode.RoundResultSavingFailed:
                return $localize`Round result saving failed`;
            default:
                // eslint-disable-next-line no-console
                console.warn(`Unknown error code: ${String(value)}`);
                return value;
        }
    }
}
